export default __webpack_public_path__ + "static/media/countries.34e633c5.svg";